var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTurnPositionRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    viewBox: "0 0 27 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_turnRight)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "filled",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8904 1C22.4635 1 22.0541 1.16493 21.7522 1.45851C21.4504 1.75209 21.2808 2.15026 21.2808 2.56545V5.85445C19.9415 4.52581 18.2766 3.55059 16.4427 3.02065C14.6089 2.49071 12.6665 2.42349 10.7986 2.82532C8.93065 3.22715 7.19863 4.0848 5.76566 5.3175C4.33269 6.5502 3.24594 8.11736 2.60776 9.87139C2.53034 10.0667 2.49397 10.2751 2.50081 10.4843C2.50766 10.6935 2.55757 10.8993 2.64759 11.0894C2.73762 11.2795 2.86594 11.4502 3.02496 11.5912C3.18398 11.7322 3.37046 11.8409 3.57339 11.9106C3.77631 11.9803 3.99156 12.0098 4.20639 11.9972C4.42122 11.9846 4.63127 11.9302 4.82413 11.8373C5.01698 11.7444 5.18871 11.6148 5.32917 11.4562C5.46963 11.2976 5.57596 11.1132 5.64187 10.914C6.12775 9.57836 6.97711 8.39597 8.09944 7.49281C9.22178 6.58965 10.575 5.99954 12.015 5.78539C13.455 5.57123 14.9277 5.74103 16.2763 6.27672C17.6248 6.8124 18.7987 7.69388 19.6728 8.82723H14.8424C14.4155 8.82723 14.0061 8.99216 13.7042 9.28574C13.4023 9.57932 13.2328 9.9775 13.2328 10.3927C13.2328 10.8079 13.4023 11.206 13.7042 11.4996C14.0061 11.7932 14.4155 11.9581 14.8424 11.9581H22.8904C23.3173 11.9581 23.7267 11.7932 24.0286 11.4996C24.3304 11.206 24.5 10.8079 24.5 10.3927V2.56545C24.5 2.15026 24.3304 1.75209 24.0286 1.45851C23.7267 1.16493 23.3173 1 22.8904 1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_turnRight",
    x: 0.5,
    y: 0,
    width: 26,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTurnPositionRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TurnPositionRight.8f69a7668c655dd14afbdb8952f4c8e6.svg";